import { createAction, Action } from 'redux-actions';

export const actionTypes = {
  SELECT_CLINIC_ADHERENCE: 'SELECT_CLINIC_ADHERENCE',
};

export const selectClinic: (
  clinicName: string,
) => Action<{ clinicId: string }> = createAction(
  actionTypes.SELECT_CLINIC_ADHERENCE,
  (clinicId: string): { clinicId: string } => ({
    clinicId,
  }),
);
